import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { isEmpty, isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import * as Yup from 'yup';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
  Input,
  Select,
  Hidden,
} from '~/components/Form';
import { Select as SelectV2 } from '~/components/Form/v2';
import { MODULO_20_GRAUS } from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';

function RelResumoGeral() {
  const [open, setOpen] = useState(true);
  const [resumo, setResumo] = useState('M');
  const [valuePosto, setValuePosto] = React.useState([]);
  const [datahorainicial, setDatahorainicial] = React.useState(null);
  const [datahorafinal, setDatahorafinal] = React.useState(null);
  // const [horainicial, setHorainicial] = React.useState(null);
  // const [horafinal, setHorafinal] = React.useState(null);
  const [turnos1, setTurnos1] = React.useState([]);
  const [turnos2, setTurnos2] = React.useState([]);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const { client } = useSelector((state) => state.user.profile);

  function handleSerializeForm(params) {
    // const idPosto =  valuePosto === 0 ? '' : valuePosto.map((posto) => posto.idposto);
    const idPosto = valuePosto.idposto === null ? '' : valuePosto.idposto;
    const idProduto = params.idproduto === null ? '' : params.idproduto;

    return {
      ...params,
      idposto: idPosto,
      idproduto: idProduto,
    };
  }

  async function handleValidate(param) {
    try {
      console.log(param);
      const schema = Yup.object().shape({
        idproduto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        mes:
          resumo === 'M' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        mes1:
          resumo === 'E' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        ano1:
          resumo === 'E' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        mes2:
          resumo === 'E' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        ano2:
          resumo === 'E' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        unidadecomboio:
          (resumo === 'E' || resumo === 'T') &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        horainicial:
          resumo === 'T' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        horafinal:
          resumo === 'T' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  const getTurnos = React.useCallback(async (params) => {
    try {
      const { data } = await api.get('/turnos/resumoturnohoracompleta', {
        params: {
          idposto: params.idposto,
          idcliente: client,
          dataturno: params.dataturno,
          pesquisalista: params.pesquisalista,
        },
        paramsSerializer: (q) => qs.stringify(q),
      });

      if (params.queturno === 1) {
        setTurnos1([
          { label: 'Nenhum', value: '' },
          ...(Array.isArray(data)
            ? data.map((item) => ({
                label: item.horaturno,
                value: item.horaturno,
              }))
            : []),
        ]);
      } else {
        setTurnos2([
          { label: 'Nenhum', value: '' },
          ...(Array.isArray(data)
            ? data.map((item) => ({
                label: item.horaturno,
                value: item.horaturno,
              }))
            : []),
        ]);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  React.useEffect(() => {
    if (!isEmpty(valuePosto) && !isEmpty(datahorainicial)) {
      getTurnos({
        queturno: 1,
        idposto: valuePosto.idposto,
        dataturno: datahorainicial,
        pesquisalista: true,
      });
    }
  }, [valuePosto, datahorainicial]);

  React.useEffect(() => {
    if (!isEmpty(valuePosto) && !isEmpty(datahorafinal)) {
      getTurnos({
        queturno: 2,
        idposto: valuePosto.idposto,
        dataturno: datahorafinal,
        pesquisalista: true,
      });
    }
  }, [valuePosto, datahorafinal]);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.resumogeral')}
      relatorio="relresumogeral"
      serialize={(param) => handleSerializeForm(param)}
      validate={(param) => handleValidate(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        resumo: 'M',
        mes: (moment().month() + 1).toString(),
        ano: end.format('YYYY'),
        mes1: (moment().month() + 1).toString(),
        ano1: end.format('YYYY'),
        mes2: (moment().month() + 1).toString(),
        ano2: end.format('YYYY'),
        horainicial: '',
        horafinal: '',
      }}
    >
      <Select
        label="Resumo"
        name="resumo"
        options={[
          { value: 'M', label: t('s.relatorio.geral.mensal') },
          { value: 'P', label: t('s.geral.periodo') },
          { value: 'E', label: t('s.relatorio.geral.evolutivomensal') },
          { value: 'T', label: t('s.relatorio.geral.evolutivoturno') },
        ]}
        getValue={(value) => setResumo(value)}
      />

      <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        defaultValue=""
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setValuePosto(value);
        }}
      />

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        // first={[{ nomeproduto: 'Todos', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'nomeproduto' }]}
      />

      {resumo === 'P' && (
        <>
          <DateTime
            label={t('s.geral.opcoes.datahorainicial')}
            name="datahorainicial"
            time
          />

          <DateTime
            label={t('s.geral.opcoes.datahorafinal')}
            name="datahorafinal"
            serialize={(value) =>
              value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
            time
          />
        </>
      )}

      {resumo === 'M' && (
        <>
          <Select
            label={t('s.geral.mes')}
            name="mes"
            options={[
              { value: '1', label: t('s.geral.opcoes.janeiro') },
              { value: '2', label: t('s.geral.opcoes.fevereiro') },
              { value: '3', label: t('s.geral.opcoes.marco') },
              { value: '4', label: t('s.geral.opcoes.abril') },
              { value: '5', label: t('s.geral.opcoes.maio') },
              { value: '6', label: t('s.geral.opcoes.junho') },
              { value: '7', label: t('s.geral.opcoes.julho') },
              { value: '8', label: t('s.geral.opcoes.agosto') },
              { value: '9', label: t('s.geral.opcoes.setembro') },
              { value: '10', label: t('s.geral.opcoes.outubro') },
              { value: '11', label: t('s.geral.opcoes.novembro') },
              { value: '12', label: t('s.geral.opcoes.dezembro') },
            ]}
          />

          <Input label={t('s.geral.ano')} name="ano" type="number" />
        </>
      )}

      {resumo === 'E' && (
        <>
          <Select
            label={t('s.geral.mes.inicio')}
            name="mes1"
            options={[
              { value: '1', label: t('s.geral.opcoes.janeiro') },
              { value: '2', label: t('s.geral.opcoes.fevereiro') },
              { value: '3', label: t('s.geral.opcoes.marco') },
              { value: '4', label: t('s.geral.opcoes.abril') },
              { value: '5', label: t('s.geral.opcoes.maio') },
              { value: '6', label: t('s.geral.opcoes.junho') },
              { value: '7', label: t('s.geral.opcoes.julho') },
              { value: '8', label: t('s.geral.opcoes.agosto') },
              { value: '9', label: t('s.geral.opcoes.setembro') },
              { value: '10', label: t('s.geral.opcoes.outubro') },
              { value: '11', label: t('s.geral.opcoes.novembro') },
              { value: '12', label: t('s.geral.opcoes.dezembro') },
            ]}
          />

          <Input label={t('s.geral.ano.inicio')} name="ano1" type="number" />

          <Select
            label={t('s.geral.mes.fim')}
            name="mes2"
            options={[
              { value: '1', label: t('s.geral.opcoes.janeiro') },
              { value: '2', label: t('s.geral.opcoes.fevereiro') },
              { value: '3', label: t('s.geral.opcoes.marco') },
              { value: '4', label: t('s.geral.opcoes.abril') },
              { value: '5', label: t('s.geral.opcoes.maio') },
              { value: '6', label: t('s.geral.opcoes.junho') },
              { value: '7', label: t('s.geral.opcoes.julho') },
              { value: '8', label: t('s.geral.opcoes.agosto') },
              { value: '9', label: t('s.geral.opcoes.setembro') },
              { value: '10', label: t('s.geral.opcoes.outubro') },
              { value: '11', label: t('s.geral.opcoes.novembro') },
              { value: '12', label: t('s.geral.opcoes.dezembro') },
            ]}
          />

          <Input label={t('s.geral.ano.fim')} name="ano2" type="number" />
        </>
      )}

      {resumo === 'T' && (
        <>
          <DateTime
            label={t('s.geral.opcoes.datahorainicial')}
            name="datahorainicial"
            time
            getValue={(value) => setDatahorainicial(value)}
          />

          <SelectV2
            name="horainicial"
            label={t('s.menu.operacao.turno')}
            data={turnos1}
          />

          <DateTime
            label={t('s.geral.opcoes.datahorafinal')}
            name="datahorafinal"
            serialize={(value) =>
              value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
            time
            getValue={(value) => setDatahorafinal(value)}
          />

          <SelectV2
            name="horafinal"
            label={t('s.menu.operacao.turno')}
            data={turnos2}
          />
        </>
      )}

      {/* <RadioGroup
        name="tipo"
        label={t('s.configuracao.produto.tipoproduto')}
        options={[
          { label: t('s.relatorio.geral.manifestado'), value: 'Manifestado' },
          { label: t('s.relatorio.geral.recebido'), value: 'Recebido' },
        ]}
        defaultValue="Recebido"
        serialize={(value) => value}
        row
      /> */}

      {!can(MODULO_20_GRAUS) && (
        <Hidden name="tiporelatorio" value="ambiente" />
      )}

      {can(MODULO_20_GRAUS) && (
        <RadioGroup
          name="tiporelatorio"
          label={t('s.relatorio.geral.tiporelatorio')}
          options={[
            {
              label: t('s.relatorio.geral.ambiente'),
              value: 'ambiente',
            },
            {
              label: t('s.relatorio.geral.20graus'),
              value: '20graus',
            },
          ]}
          defaultValue="ambiente"
          serialize={(value) => value}
          row
        />
      )}

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelResumoGeral;
